import { render, staticRenderFns } from "./addBusinessDialog.vue?vue&type=template&id=24b4fd47"
import script from "./addBusinessDialog.vue?vue&type=script&lang=js"
export * from "./addBusinessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports